import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28')
];

export const server_loads = [];

export const dictionary = {
		"/": [7],
		"/browse": [11,[3]],
		"/browse/[...wordId]": [12,[3]],
		"/comparison": [13,[4]],
		"/comparison/vocabeo-vs-anki": [14,[4]],
		"/comparison/vocabeo-vs-clozemaster": [15,[4]],
		"/comparison/vocabeo-vs-duolingo": [16,[4]],
		"/comparison/vocabeo-vs-quizlet": [17,[4]],
		"/learn": [18],
		"/legal/cookie": [19,[5],[6]],
		"/legal/notice": [20,[5],[6]],
		"/legal/privacy": [21,[5],[6]],
		"/legal/terms": [22,[5],[6]],
		"/(await-setup)/next-feature": [8,[2]],
		"/pricing": [23],
		"/resources": [24],
		"/settings": [25],
		"/signin": [26],
		"/stats": [27],
		"/subscription": [28],
		"/(await-setup)/testimonial": [9,[2]],
		"/[...unknown]": [10]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';